/**
 * Jainsons Lights — Advanced Behavior Tracker v3.0
 * ~4KB async, non-blocking, Cloudflare-compatible
 *
 * EVENTS TRACKED:
 * ─ Core: page_view, scroll, heartbeat, exit
 * ─ CTA: cta_whatsapp, cta_call, cta_form_submit, cta_custom, cta_visible
 * ─ Buyer Signals: copy_event (price/product copy), hover_dwell, pinch_zoom
 * ─ UX Issues: rage_click, dead_click, js_error
 * ─ Engagement: tab_hidden, tab_returned (competitor check), internal_search
 * ─ Product: product_view (on product pages)
 * ─ Performance: LCP, TTFB, load time
 *
 * INSTALL: Add to Shopify theme.liquid before </body>:
 *   <script src="https://YOUR_SERVER/tracking.js" async defer></script>
 *
 * CONFIG (optional):
 *   window.__JL_TRACK_URL = 'https://your-server.com/api/track';
 *   window.__JL_DEBUG = true;
 */
(function(w, d) {
  'use strict';

  var CFG = {
    endpoint: w.__JL_TRACK_URL || 'https://seo-engine.jainsonslights.com/api/track',
    heartbeatSec: 30,
    scrollThrottleMs: 400,
    hoverDwellMs: 2500,
    batchIntervalMs: 5000,
    returnVisitGapMs: 30 * 60 * 1000,
    debug: w.__JL_DEBUG || false
  };

  // ── State ──
  var queue = [];
  var sid = getOrCreate('jl_sid', function() { return rand(12); });
  var vid = getOrCreate('jl_vid', function() { return rand(16); });
  var isReturn = checkReturn();
  var loadTime = Date.now();
  var scrollReached = {};
  var maxScroll = 0;
  var totalActive = 0;
  var isActive = true;
  var tabHiddenAt = 0;
  var ctaClicked = false;
  var clickBuf = [];

  // ── Core Send ──
  function track(event, props) {
    var payload = {
      v: 3, e: event, u: location.pathname, s: sid, vid: vid,
      t: new Date().toISOString(),
      r: d.referrer ? d.referrer.substring(0, 200) : '',
      d: getDevice(),
      vp: { w: innerWidth, h: innerHeight },
      ret: isReturn, pt: getPageType(),
      p: props || {},
      cid: w.__JL_CID || undefined
    };
    if (event === 'page_view') payload.utm = getUTM();
    queue.push(payload);
    if (CFG.debug) console.log('[JL]', event, props);
  }  w.jlTrack = track; // JL-WELCOME-001: shared tracker hook (29 Oct 2026)


  function flush() {
    if (!queue.length) return;
    var batch = queue.splice(0);
    var body = JSON.stringify(batch);
    if (navigator.sendBeacon) navigator.sendBeacon(CFG.endpoint, body);
    else fetch(CFG.endpoint, { method: 'POST', body: body, headers: {'Content-Type':'application/json'}, keepalive: true }).catch(function(){});
  }

  setInterval(flush, CFG.batchIntervalMs);
  d.addEventListener('visibilitychange', function() { if (d.visibilityState === 'hidden') flush(); });
  // Finder events (Product finder & filter chat, 27 Oct): forwarded with this tracker's own ids for the reminders engine.
  w.addEventListener('jl:finder', function (ev) {
    var x = (ev && ev.detail) || {}; if (!x.event) return;
    var p = {}; for (var k in x) { if (k !== 'event') p[k] = x[k]; }
    track(x.event, p);
    if (x.event === 'finder_result' || x.event === 'finder_whatsapp') flush();
  });

  // ── Page View ──
  track('page_view', { tt: d.title.substring(0, 80), net: getNetwork() });

  // ── Performance (after load) ──
  w.addEventListener('load', function() {
    var perf = performance.getEntriesByType('navigation')[0];
    if (perf) track('perf', { dom: Math.round(perf.domContentLoadedEventEnd), load: Math.round(perf.loadEventEnd), ttfb: Math.round(perf.responseStart - perf.requestStart) });
  });

  // ── Scroll Depth ──
  var milestones = [10, 25, 50, 75, 90, 100];
  w.addEventListener('scroll', throttle(function() {
    var scrollable = d.body.scrollHeight - innerHeight;
    var pct = scrollable > 0 ? Math.round((scrollY / scrollable) * 100) : 100;
    maxScroll = Math.max(maxScroll, pct);
    milestones.forEach(function(m) {
      if (pct >= m && !scrollReached[m]) {
        scrollReached[m] = true;
        track('scroll', { dp: m, ms: Date.now() - loadTime });
      }
    });
  }, CFG.scrollThrottleMs), { passive: true });

  // ── Heartbeat ──
  setInterval(function() {
    if (isActive) { totalActive += CFG.heartbeatSec; track('hb', { sec: totalActive, ms: maxScroll }); }
  }, CFG.heartbeatSec * 1000);

  // ── Tab Visibility (competitor check detection) ──
  d.addEventListener('visibilitychange', function() {
    isActive = d.visibilityState === 'visible';
    if (!isActive) { track('tab_hide', { sec: totalActive }); tabHiddenAt = Date.now(); }
    else { var away = Date.now() - tabHiddenAt; track('tab_back', { away: away, comp: away > 60000 }); }
  });

  // ── Rage Click + Dead Click Detection ──
  d.addEventListener('click', function(e) {
    var now = Date.now();
    clickBuf.push({ x: e.clientX, y: e.clientY, t: now });
    while (clickBuf.length > 0 && now - clickBuf[0].t > 2000) clickBuf.shift();

    // Rage: 3+ clicks in 2s within 50px
    if (clickBuf.length >= 3) {
      var recent = clickBuf.slice(-3);
      var xSpread = Math.max.apply(null, recent.map(function(c){return c.x})) - Math.min.apply(null, recent.map(function(c){return c.x}));
      var ySpread = Math.max.apply(null, recent.map(function(c){return c.y})) - Math.min.apply(null, recent.map(function(c){return c.y}));
      if (xSpread < 50 && ySpread < 50) {
        track('rage', { el: sel(e.target), x: e.clientX, y: e.clientY, n: clickBuf.length });
        clickBuf = [];
      }
    }

    // Dead click: non-interactive element
    if (!e.target.closest('a, button, input, select, textarea, [onclick], [data-track]')) {
      track('dead', { el: sel(e.target), tx: (e.target.innerText || '').trim().substring(0, 40) });
    }
  }, true);

  // ── CTA Click Tracking ──
  d.addEventListener('click', function(e) {
    var el = e.target.closest('a, button, [data-track]');
    if (!el) return;
    var href = el.href || '', text = (el.innerText || '').trim().substring(0, 60);

    if (href.indexOf('wa.me') !== -1 || href.indexOf('whatsapp') !== -1) {
      ctaClicked = true; track('cta_wa', { tx: text, sec: totalActive, ms: maxScroll });
      // Fire Google Ads conversion for "Whats app me" action (AW-936554003 / label 0w31CPGaiI4YEJPcyr4D)
      if (typeof w.gtag === 'function') {
        w.gtag('event', 'conversion', { 'send_to': 'AW-936554003/0w31CPGaiI4YEJPcyr4D' });
      }
    } else if (href.indexOf('tel:') === 0) {
      track('cta_call', { tx: text, tel: href });
      // Fire Google Ads conversion for "Phone click on website" action (AW-936554003 / label HffwCN_wt6wcEJPcyr4D)
      if (typeof w.gtag === 'function') {
        w.gtag('event', 'conversion', { 'send_to': 'AW-936554003/HffwCN_wt6wcEJPcyr4D' });
      }
    } else if (el.closest('form')) {
      track('cta_form', { tx: text });
    } else if (el.dataset && el.dataset.track) {
      track('cta', { ct: el.dataset.track, tx: text });
    }

    // Add to cart / enquire
    var lc = text.toLowerCase();
    if (lc.indexOf('add to cart') !== -1 || lc.indexOf('buy') !== -1) track('cta_atc', { tx: text });
    if (lc.indexOf('enquir') !== -1 || lc.indexOf('quote') !== -1) track('cta_enq', { tx: text });
  });

  // ── Copy-Paste (Buyer Signal) ──
  d.addEventListener('copy', function() {
    var sel = w.getSelection();
    var text = sel ? sel.toString().trim() : '';
    if (text.length > 0) {
      track('copy', {
        tx: text.substring(0, 100),
        price: /[₹$]|price|cost|\d{4,}/i.test(text),
        prod: text.length < 60
      });
    }
  });

  // ── Hover Dwell (product interest) ──
  var hoverTimer = null;
  d.addEventListener('mouseover', function(e) {
    var el = e.target.closest('.product-card, .product-image, [data-hover-track]');
    if (!el) return;
    hoverTimer = setTimeout(function() {
      track('hover', { el: sel(el), pid: el.dataset ? el.dataset.productId : '' });
    }, CFG.hoverDwellMs);
  });
  d.addEventListener('mouseout', function() { if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; } });

  // ── CTA Visibility (Intersection Observer) ──
  if (w.IntersectionObserver) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          track('cta_vis', { el: sel(entry.target), ms: Date.now() - loadTime });
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    d.addEventListener('DOMContentLoaded', function() {
      d.querySelectorAll('.whatsapp-btn, [data-track="whatsapp"], a[href*="wa.me"]').forEach(function(el) { obs.observe(el); });
    });
  }

  // ── Exit Intent ──
  var exitDone = false;
  d.addEventListener('mouseleave', function(e) {
    if (e.clientY <= 10 && !exitDone) {
      exitDone = true;
      track('exit_intent', { sec: totalActive, ms: maxScroll, wa: ctaClicked });
      flush();
    }
  });

  // ── Internal Search ──
  d.querySelectorAll('input[type="search"], #SearchInput, .search-input').forEach(function(input) {
    input.addEventListener('change', function() { if (input.value.trim()) track('search', { q: input.value.trim() }); });
  });

  // ── Product View (extra data on product pages) ──
  if (getPageType() === 'product') {
    var ogTitle = d.querySelector('meta[property="og:title"]');
    var ogPrice = d.querySelector('meta[property="product:price:amount"]');
    track('prod', { name: ogTitle ? ogTitle.content.substring(0, 60) : '', price: ogPrice ? ogPrice.content : '', handle: location.pathname.split('/products/')[1] || '' });
  }

  if (getPageType() === 'collection') {
    initCollectionTracking();
  }

  // ── JS Error Tracking ──
  w.addEventListener('error', function(e) {
    track('err', { msg: (e.message || '').substring(0, 200), src: (e.filename || '').replace(location.origin, ''), line: e.lineno });
  });

  // ── Mobile Pinch/Zoom ──
  var lastDist = 0;
  d.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) lastDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
  });
  d.addEventListener('touchmove', throttle(function(e) {
    if (e.touches.length === 2) {
      var dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
      if (Math.abs(dist - lastDist) > 30) { track('zoom', { dir: dist > lastDist ? 'in' : 'out' }); lastDist = dist; }
    }
  }, 500));

  // ── Page Exit ──
  w.addEventListener('pagehide', function() {
    track('exit', { total_ms: Date.now() - loadTime, sec: totalActive, ms: maxScroll, wa: ctaClicked });
    flush();
  });

  // ── Helpers ──
  function getOrCreate(k, fn) { try { var v = localStorage.getItem(k); if (!v) { v = fn(); localStorage.setItem(k, v); } return v; } catch(e) { return fn(); } }
  function rand(n) { return Math.random().toString(36).substring(2, 2 + n); }
  function throttle(fn, ms) { var t = 0; return function() { var now = Date.now(); if (now - t > ms) { t = now; fn.apply(null, arguments); } }; }
  function getPageType() { var p = location.pathname; if (p === '/') return 'home'; if (p.indexOf('/collections/') === 0) return 'collection'; if (p.indexOf('/products/') === 0) return 'product'; if (p.indexOf('/pages/') === 0) return 'page'; if (p.indexOf('/blogs/') === 0) return 'blog'; return 'other'; }
  function getUTM() { var p = new URLSearchParams(location.search); function id(n) { var v = p.get(n); return v ? v.slice(0, 64) : null; } return { s: p.get('utm_source'), m: p.get('utm_medium'), c: p.get('utm_campaign'), k: p.get('utm_term'), g: p.get('gclid'), jl_cid: id('jl_cid'), jl_agid: id('jl_agid'), jl_kwid: id('jl_kwid') }; }
  function getDevice() { return /Mobi|Android/i.test(navigator.userAgent) ? 'm' : 'd'; }
  function getNetwork() { var c = navigator.connection; return c ? c.effectiveType : null; }
  function parseNum(v) { var n = parseFloat(v); return Number.isFinite(n) ? n : 0; }
  function getCurrency() { return (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || ''; }
  function pushDataLayerEvent(eventName, ecommerce) {
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ ecommerce: null });
    w.dataLayer.push({ event: eventName, ecommerce: ecommerce });
  }
  function getTrackedProductCard(el) {
    return el && el.closest ? el.closest('[data-jl-product-card]') : null;
  }
  function readProductCard(card) {
    if (!card || !card.dataset) return null;
    var ds = card.dataset;
    if (!ds.jlProductId || !ds.jlListId) return null;
    return {
      item_id: ds.jlProductId,
      item_name: ds.jlProductTitle || '',
      item_brand: ds.jlProductVendor || '',
      item_category: ds.jlProductType || '',
      item_variant: ds.jlVariantId || '',
      item_list_id: ds.jlListId || '',
      item_list_name: ds.jlListName || '',
      item_handle: ds.jlProductHandle || '',
      index: parseInt(ds.jlListPosition || '0', 10) || 0,
      price: parseNum(ds.jlProductPrice) / 100,
      currency: ds.jlCurrency || getCurrency(),
      product_url: ds.jlProductUrl || ''
    };
  }
  function toTrackItem(item) {
    return {
      id: item.item_id,
      h: item.item_handle,
      n: item.item_name,
      v: item.item_brand,
      c: item.item_category,
      p: item.index,
      pr: item.price
    };
  }
  function trackCollectionViewBatch(cards) {
    var grouped = {};
    cards.forEach(function(card) {
      if (!card || card.dataset.jlListViewTracked === '1') return;
      var item = readProductCard(card);
      if (!item) return;
      card.dataset.jlListViewTracked = '1';
      var key = item.item_list_id + '::' + item.item_list_name;
      if (!grouped[key]) {
        grouped[key] = {
          currency: item.currency,
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          items: []
        };
      }
      grouped[key].items.push(item);
    });
    Object.keys(grouped).forEach(function(key) {
      var payload = grouped[key];
      if (!payload.items.length) return;
      pushDataLayerEvent('view_item_list', payload);
      track('list_view', {
        list_id: payload.item_list_id,
        list_name: payload.item_list_name,
        cur: payload.currency,
        count: payload.items.length,
        items: payload.items.map(toTrackItem)
      });
    });
  }
  function scanCollectionProductCards(root) {
    var scope = root || d;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-jl-product-card]'));
    if (!cards.length) return;
    trackCollectionViewBatch(cards);
  }
  function initCollectionTracking() {
    var container = d.getElementById('ProductGridContainer') || d.getElementById('product-grid');
    scanCollectionProductCards(container || d);

    d.addEventListener('click', function(e) {
      var link = e.target.closest ? e.target.closest('[data-jl-track-select="true"]') : null;
      if (!link) return;
      var item = readProductCard(getTrackedProductCard(link));
      if (!item) return;
      pushDataLayerEvent('select_item', {
        currency: item.currency,
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        items: [item]
      });
      track('list_select', {
        list_id: item.item_list_id,
        list_name: item.item_list_name,
        cur: item.currency,
        item: toTrackItem(item)
      });
    }, true);

    d.addEventListener('click', function(e) {
      var button = e.target.closest ? e.target.closest('.quick-add__submit') : null;
      if (!button) return;
      var item = readProductCard(getTrackedProductCard(button));
      if (!item) return;
      pushDataLayerEvent('jl_add_to_cart_from_list', {
        currency: item.currency,
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        items: [item]
      });
      track('list_atc', {
        list_id: item.item_list_id,
        list_name: item.item_list_name,
        cur: item.currency,
        item: toTrackItem(item)
      });
    }, true);

    if (container && w.MutationObserver) {
      var scanNewCards = throttle(function() {
        scanCollectionProductCards(container);
      }, 500);
      var observer = new MutationObserver(function() { scanNewCards(); });
      observer.observe(container, { childList: true, subtree: true });
    }
  }
  function sel(el) { if (!el) return ''; if (el.id) return '#' + el.id; if (el.className && typeof el.className === 'string') return el.tagName.toLowerCase() + '.' + el.className.split(' ').slice(0, 2).join('.'); return el.tagName ? el.tagName.toLowerCase() : ''; }
  function checkReturn() { var l = localStorage.getItem('jl_lv'); var now = Date.now(); localStorage.setItem('jl_lv', now); return l && (now - parseInt(l)) > CFG.returnVisitGapMs; }
}(window, document));

/* CUSTOM-START: ARIA-CHAT-001 | Cache-safe Aria widget loader | 2026-06-18 */
(function(w, d) {
  'use strict';
  if (w.__JL_ARIA_LOADER_DONE) return;
  w.__JL_ARIA_LOADER_DONE = true;

  function loadAria() {
    if (d.querySelector('.jl-aria') || d.querySelector('script[src*="aria-widget.js"]')) return;
    w.JL_CUSTOMER = w.JL_CUSTOMER || { logged_in: false };

    var script = d.createElement('script');
    script.id = 'jl-aria-widget-loader';
    script.src = 'https://aria.jainsonslights.com/static/aria-widget.js';
    script.defer = true;
    script.setAttribute('data-api', 'https://aria.jainsonslights.com');
    script.setAttribute('data-whatsapp', '919899188821');
    (d.body || d.documentElement).appendChild(script);
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', loadAria, { once: true });
  } else {
    loadAria();
  }
}(window, document));
/* CUSTOM-END: ARIA-CHAT-001 */
